'use client';

import styled from 'styled-components';

type Props = {
  animationDuration: number;
  progress: number;
};

export const Bar = styled.div<Props>`
  background: var(--primary-3);
  height: 4px;
  left: 0;
  top: 0;
  margin-right: ${({ progress }) => (1 - progress) * 100}%;
  transition: ${({ animationDuration }) => `margin-right ${animationDuration}ms linear`};
`;
